export default [
  'components-badge-small',
  'components-badge-small-bold',
  'components-badge-small-italic',
  'components-badge-medium',
  'components-badge-medium-bold',
  'components-badge-medium-italic',
]
